<div class="modal-header">
  <h6 class="modal-title">Admin : Course Management : Add/ Edit MockExam</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <!-- mock-exam-form.component.html -->
  <form [formGroup]="addEditForm">
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Mock Exam ID</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="text"
            id="mockExamId"
            class="form-control form-control-sm"
            formControlName="mockExamId"
          />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Exam Number</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="text"
            id="mockExamSeqNumber"
            class="form-control form-control-sm"
            formControlName="mockExamSeqNumber"
          />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Exam Series Type</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <select
            id="examSeries"
            class="form-control form-control-sm"
            formControlName="examSeriesType"
          >
            <option value="">Select Exam Series</option>
            <option *ngFor="let status of examSeriesType" [value]="status.Code">
              {{ status.Description }}
            </option>
          </select>
          <small
            *ngIf="
              addEditForm.get('examSeriesType')?.touched &&
              addEditForm.get('examSeriesType')?.hasError('required')
            "
            style="color: red"
          >
            Field is required
          </small>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15"># of Questions</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="number"
            id="noOfQuestion"
            class="form-control form-control-sm w-25 text-end"
            formControlName="noOfQuestion"
            step="1"
            min="0"
            (keypress)="preventDecimal($event)"
          />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Total Score</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="text"
            id="totalScore"
            class="form-control form-control-sm w-25 text-end"
            mask="separator.2"
            thousandSeparator=""
            separatorLimit="9999"
            formControlName="totalScore"
          />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Status</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <select
            id="status"
            class="form-control form-control-sm"
            formControlName="status"
          >
            <option value="">Select Status</option>
            <option *ngFor="let status of statuses" [value]="status.Code">
              {{ status.Description }}
            </option>
          </select>
          <small
            *ngIf="
              addEditForm.get('status')?.touched &&
              addEditForm.get('status')?.hasError('required')
            "
            style="color: red"
          >
            Field is required
          </small>
        </div>
      </div>
    </div>


    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Applicable Course Plan</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <div class="form-check" *ngFor="let course of courses">
            <input
              type="checkbox"
              class="form-check-input"
              [disabled]="disablecheckboxes(course.Code)"
              [id]="course.Code"
              [value]="course.Code"
              [checked]="checkedCoursePlan(course.Code)"
              (change)="onCourseChange($event)"
            />
            <label class="form-check-label f-15" [for]="course.Code">{{
              course.Description
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm bl-btn" (click)="onSubmit()">
    Save
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border"
    (click)="activeModal.dismiss('Cross click')"
  >
    Cancel
  </button>
</div>
